<template>
  <div class="container">
    <div class="mainPart applyForAccountCancellationStep">
      <span class="iconfont icon-warn1"></span>
      <span class="title">账号注销后，将无法恢复以下资产和权益，请详细阅读后再点击下一步</span>
      <div class="detail">
        <br />
        1.该账号将无法登录、使用搜货精选平台（包括微信公众号网页和APP），并移除该账号下所有登录方式<br />
        <br />
        2.账号中已有和待领取的免单卡以及其他权益将无法使用<br />
        <br />
        3.移除该账号下的实名认证信息<br />
        <br />
        4.该账号下的个人资料和订单信息都将无法找回<br />
        <br />
        <span class="alert">5.出于平台数据考虑，当前注销手机号将无法再次注册搜货精选平台账号</span><br />
      </div>
    </div>
    <div class="optBox">
      <div class="ApplyForAccountCancellationStep1AgreementPart">
        <div class="con">
          <i class="iconfont" :class="isAgree ? 'active icon-dagou' : 'icon-kuang'" @click="isAgree = !isAgree"></i>
          <span @click="isAgree = !isAgree">我已阅读并知晓了</span>
          <span class="link tapActive" @click="$router.push('accountCancellationNotice')">《搜货精选注销须知》</span>
        </div>
      </div>
      <div class="btn alert tapActive" @click.stop="next">下一步</div>
      <div class="btn normal tapActive" @click.stop="$router.go(-1)">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applyForAccountCancellationStep1',
  data() {
    return {
      isAgree: false
    }
  },
  methods: {
    next() {
      if (!this.isAgree) {
        this.$toast('请先阅读并同意协议')
        return
      }
      this.$router.replace({
        name: 'applyForAccountCancellationStep2'
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!['accountCancellationNotice'].includes(from.name)) {
        vm.isAgree = false
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$toast.clear()
    next()
  }
}
</script>

<style lang="scss" scoped>
@import './css/applyForAccountCancellationStep';
.container {
  padding-top: vw(20);
  .mainPart {
    .detail {
      border-top: 1px solid #e3e3e3;
      margin-top: vw(15);
      color: #3d3d3d;
      font-size: vw(14);
      .alert {
        color: #fa252c;
      }
    }
  }
}
</style>
